import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'

const styles = theme => ({
  container: {
    margin: '8px 0',
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing.unit,
    },
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  keywordLink: {
    display: 'inline-block',
    width: '100%',
  },
})
const keywordList = [
  '分蜂',
  'キンリョウヘン',
  '分蜂時期',
  '待ち箱設置場所',
  '待ち箱ルアー',
]

class StartScreen extends React.Component {
  handleClick = e => {
    const keyword = e.target.text
    this.props.search(keyword)
  }
  render() {
    const { classes } = this.props
    return (
      <Grid className={classes.container}>
        <Paper className={classes.paper}>
          <Typography variant="h6">おすすめの検索キーワード</Typography>
          <List>
            {keywordList.map((keyword,index) => {
              return (
                <ListItem key={index} button divider>
                  <ListItemText
                    primary={
                      <Typography variant="h5">
                        <Link
                          underline="none"
                          className={classes.keywordLink}
                          onClick={this.handleClick}
                        >
                          {keyword}
                        </Link>
                      </Typography>
                    }
                  />
                </ListItem>
              )
            })}
          </List>
        </Paper>
      </Grid>
    )
  }
}

StartScreen.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(StartScreen)
